import React from 'react';
import MUIDataTable from 'mui-datatables';
import ActivityFeatureAdd from "./ActivityFeatureAdd";
import ActivityFeatureEdit from "./ActivityFeatureEdit";
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import cloneDeep from 'lodash.clonedeep';
import SortColButton from "../SortColButton";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import { authFetch, authPost } from "../../authProvider";
import { ExportDataButtons } from '../ExportDataButtons';
import { LanguageContext } from '../LanguageContext';
import moment from 'moment';

/* Näkymäkohtaiset muuttujat ja vakiot */
const API_ACTIVITY_PREFIX = 'api/Activity';
const API_ACTIVITYFEATURE_PREFIX = 'api/ActivityFeature';

const API_DATAEXPORT_PREFIX = 'api/export/table';

const default_columns = [
    {
        label: "Id",
        name: "activityFeatureId",
        options: {
            filter: false,
            display: false
        }
    },

    {
        label: "Activity_Id",
        name: "activity_Id",
        options: {
            filter: false,
            display: true,
            customBodyRender: function (value, tableMeta, updateValue) {
                return activity[value];
            },
            lookuplist: 'activity'
        }
    },

    {
        label: "ContentType",
        name: "contentType",
        options: {
            filter: true,
            display: true
        }
    },
    {
        label: "VideoLength",
        name: "videoLength",
        options: {
            filter: true,
            display: true
        }
    },

    {
        label: "PublishWeekDay",
        name: "publishWeekDay",
        options: {
            filter: true,
            display: true,
            
        }
    },

    {
        label: "PublishTimeOfDay",
        name: "publishTimeOfDay",
        options: {
            filter: true,
            display: true,
            
        }
    },

    {
        label: "NumOfFemale",
        name: "numOfFemale",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "NumOfMale",
        name: "numOfMale",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "NumOfAnimal",
        name: "numOfAnimal",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "Location",
        name: "location",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "HasText",
        name: "hasText",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "HasMusic",
        name: "hasMusic",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "Setup",
        name: "setup",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "BaseOnTrend",
        name: "baseOnTrend",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "NumOfHastags",
        name: "numOfHastags",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "NumOfTags",
        name: "numOfTags",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "BrandShowLengthSec",
        name: "brandShowLengthSec",
        options: {
            filter: true,
            display: true,

        }
    },

    {
        label: "BrandShowPosition",
        name: "brandShowPosition",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "IsPitching",
        name: "isPitching",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "IsStrongCTA",
        name: "isStrongCTA",
        options: {
            filter: true,
            display: true,

        }
    },
    {
        label: "IsGeneralInsight",
        name: "isGeneralInsight",
        options: {
            filter: true,
            display: true,

        }
    },
  
    {
        label: "Modifier",
        name: "modifier",
        options: {
            filter: true,
            display: true,
        }
    },

    {
        label: "Updated",
        name: "startTime",
        options: {
            filter: true,
            display: true,
            customBodyRender: function (value, tableMeta, updateValue) {
                var date = moment(value).format("D.M.YYYY, HH:mm");
                return moment(value).isValid() ? date : "";
            },
        }
    },

    {
        label: "Valid Until",
        name: "endTime",
        options: {
            filter: false,
            display: false,
            customBodyRender: function (value, tableMeta, updateValue) {
                var date = moment(value).format("D.M.YYYY, HH:mm");
                return moment(value).isValid() ? date : "";
            },
        }
    }
];

/* Perusmuuttujat ja vakiot */
const PROFIILI_GET = 'api/Profiili/Read';
const PROFIILI_PUT = 'api/Profiili/Update';

var rowId;
var selectedRows = [];
var items = [];
var activity = {};
//var location = {};
//var campaign = {};

/* Luokka */
export class ActivityFeature extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        // State alustukset
        this.state = {
            lookupLists: {
                activity: activity,
                //location: location,
                //campaign: campaign,
            },
            rowsSelected: [],
            loading: true,
            rowNum: 25,
            errorShow: false,
            errorTitle: '',
            errorBody: '',
            sortOrder: { name: 'activityFeatureId', direction: 'asc' },
            route: "",
            fileData: "",
        };

        //Bindit
        this.swapCols = this.swapCols.bind(this);
        this.addNewItem = this.addNewItem.bind(this);

        // Getting Id from foreign kay

        //Channel
        authFetch(this.props.pca, API_ACTIVITY_PREFIX + '/LookupList')
            .then(response => response.json())
            .then(data => {
                data.forEach((d, i) => {
                    activity[d.activityId] = (d.name || 'ei tietoja');
                });

                //Items
                authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Read')
                    .then(response => response.json())
                    .then(data => {
                        items = data;
                        let cols = null;
                        let hidden_cols = null;
                        const columns = get_ordered_columns(cols, hidden_cols);

                        this.setState({
                            lookuplist: {
                                activity: activity,
                                
                            },
                            columns: columns,
                            data: items,
                            loading: false,
                            rowNum: 25
                        });

                    });

            });
             
    }
    
    swapCols = (index) => {
        if (index > 1) {
            var cols = cloneDeep(this.state.columns);
            var d = this.state.data;
            [cols[index - 1], cols[index]] = [cols[index], cols[index - 1]];
            this.setState({ columns: cols });
            var setting = { "key": "columns.activityFeature", "value": JSON.stringify(cols.map(function (d) { return d.name; })).split('"').join('""') }; // TODO: muuta avain
            authPost(this.props.pca, PROFIILI_PUT, {
                body: JSON.stringify(setting)
            });
        }
    };

    changeRownum = (num) => {
        this.setState({ rowNum: num })

        var setting = { "key": "rownum.activityFeature", "value": JSON.stringify(num).split('"').join('""') }; // TODO: muuta avain
        authPost(this.props.pca, PROFIILI_PUT, {
            body: JSON.stringify(setting)
        })
    };

    hiddenCols = (changedColumn, action) => {
        var cols = cloneDeep(this.state.columns);
        var hidden = [];

        for (var i = 0; i < cols.length; i++) {
            if (!(cols[i].options))
                cols[i].options = {};

            if (cols[i].name == changedColumn)
                cols[i].options.display = (action === "add" ? true : false)

            if (cols[i].options.display == false) {
                hidden.push(cols[i].name);
            }
        }

        if (action === "add") {
            hidden.splice(hidden.indexOf(changedColumn), 1);
        }
        else if (action === "remove") {
            hidden.push(changedColumn);
        }

        this.setState({ columns: cols });
        var setting = { "key": "hiddencolumns.activityFeature", "value": (hidden.length > 0 ? JSON.stringify(hidden).split('"').join('""') : "[]") }; // TODO: muuta avain
        authPost(this.props.pca, PROFIILI_PUT, {
            body: JSON.stringify(setting)
        })
    };

    handleError = (error) => {
        const { onError } = this.props;

        var title = '', body = ''
        if (error === 4) {
            title = this.context.dictionary.ErrorDialog.Error4.title;
            body = this.context.dictionary.ErrorDialog.Error4.body;
        } else if (error === 5) {
            title = this.context.dictionary.ErrorDialog.Error5.title;
            body = this.context.dictionary.ErrorDialog.Error5.body;
        } else {
            title = this.context.dictionary.ErrorDialog.Error.title;
            body = this.context.dictionary.ErrorDialog.Error.body;
        }

        onError(title, body);
    }

    handleErrorClose = () => this.setState({ errorShow: false });
    
    addNewItem = (newrow) => {
        // ADD
        authPost(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Create', {
            body: JSON.stringify(newrow)
        })
            .then(response => response.json())
            .then(data => {
                if ((data || {}).error) {
                    this.handleError(data.error);
                } else {
                    authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Read')
                        .then(response => response.json())
                        .then(data => {
                            this.setState({ data: data, rowsSelected: [] })
                            this.handleMessage(this.context.dictionary.Message.Add)
                        });
                }
            });
    }

    editItem = (newrow) => {
        // EDIT
        authPost(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Update', {
            body: JSON.stringify(newrow)
        })
            .then(response => response.json())
            .then(data => {
                if ((data || {}).error) {
                    this.handleError(data.error);
                } else {
                    authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Read')
                        .then(response => response.json())
                        .then(data => {
                            this.setState({ data: data, rowsSelected: [] })
                            this.handleMessage(this.context.dictionary.Message.Edit)
                        });
                }
            });
    }

    handleMessage = (msg) => {
        const { onMessage } = this.props;
        onMessage(msg);
    }

    handleSortChange = (changedColumn, direction) => {
        this.setState({
            sortOrder: { name: changedColumn, direction },
        });
    };
    
    render() {
        const { dictionary } = this.context;

        let cols = cloneDeep(this.state.columns);
        if ((cols || []).length > 0) {
            for (var i = 0; i < default_columns.length; i++) {
                for (var j = 0; j < cols.length; j++) {
                    if (cols[j].label == default_columns[i].label) {
                        cols[j].label = dictionary.ActivityFeature.Columns[i] //TODO: Muuta avain
                    }
                }
            }
        }

        const options = {
            textLabels: dictionary.MuiDataTable.textLabels,
            selectableRowsHeader: true,
            selectableRowsOnClick: true,
            selectableRows: "multiple",
            filterType: 'multiselect',
            responsive: "vertical",
            tableBodyHeight: "calc(100vh - 180px)",
            rowsPerPageOptions: [5, 10, 25, 50, 100],
            rowsPerPage: this.state.rowNum,
            jumpToPage: true,
            rowsSelected: this.state.rowsSelected,
            sortOrder: this.state.sortOrder,
            onColumnSortChange: this.handleSortChange,
            onViewColumnsChange: (changedColumn, action) => {
                this.hiddenCols(changedColumn, action);
            },
            onRowSelectionChange: (currentRowsSelected, allRows, rowsSelected) => {
                const { data } = this.state;
                rowId = null;
                if (rowsSelected.length > 0) {
                    rowId = data[rowsSelected[0]].activityFeatureId; //TODO: Muuta avain
                }
                this.setState({ rowsSelected: rowsSelected });
            },
            onChangeRowsPerPage: (num) => {
                this.changeRownum(num);
            },
            // Huomioi samat arvot ja sen jölkeen lajitellaan ensimmäisen sarakkeen (id) mukaan
            customSort: (data, colIndex, order) => {
                const { columns, lookupLists } = this.state;

                return data.sort((a, b) => {
                    if (a.data[colIndex] == b.data[colIndex]) {
                        // samanarvoisissa riveissä otetaan riviavainjärjestys
                        return ((a.data[0] || -9e6) < (b.data[0] || -9e6) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    } else if (columns[colIndex].options.lookuplist) {
                        // lookuplist lajittelu
                        const list = lookupLists[columns[colIndex].options.lookuplist];
                        var aa = (list[a.data[colIndex]] || ''), bb = (list[b.data[colIndex]] || '');

                        return ((parseInt(!/[^0-9]/i.test(aa) ? aa : 'x') || aa.toString()) < (parseInt(!/[^0-9]/i.test(bb) ? bb : 'x') || bb.toString()) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    } else {
                        // normaali lajittelu
                        return ((a.data[colIndex] || -9e6) < (b.data[colIndex] || -9e6) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    }
                });
            },
            customToolbarSelect: (selRows, displayData, setSelectedRows) => {
                const { data } = this.state;

                if ((selRows.data || []).length > 0) {
                    selectedRows = selRows.data.map(d => (d.dataIndex));
                    rowId = data[selectedRows[0]].activityFeatureId; //TODO: Muuta avain
                }

                var handleDelete = () => {
                    var data = cloneDeep(this.state.data);

                    if (window.confirm(dictionary.DeleteConfirmation + selectedRows.map(d => data[d].activityFeatureId).join(", "))) {
                        var requests = []
                        for (var i = 0; i < selectedRows.length; i++) {
                            requests.push(
                                authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Delete/' + data[selectedRows[i]].activityFeatureId, { method: 'delete' }) //TODO: Muuta avain
                            );
                        }
                        Promise.all(requests)
                            .then(() => {
                                setSelectedRows([]);
                                authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Read')
                                    .then(response => response.json())
                                    .then(data => {
                                        this.handleMessage(`(${selectedRows.length}) ${dictionary.Message.Delete}`)
                                        this.setState({ data: data, rowsSelected: [] });
                                    });
                            });
                    }
                }

                var handleCopy = () => {
                    const { data } = this.state;
                    if (window.confirm(dictionary.CopyConfirmation + selectedRows.map(d => data[d].activityFeatureId).join(", "))) {
                        var requests = []
                        for (var i = 0; i < selectedRows.length; i++) {
                            const row = data[selectedRows[i]];
                            var newrow = {
                                ActivityFeatureId: 1, //dummy-arvo
                                Activity_Id: row.activity_Id,
                                ContentType: row.contentType,
                                VideoLength: row.videoLength,
                                PublishWeekDay: row.publishWeekDay,
                                PublishTimeOfDay: row.publishTimeOfDay,
                                NumOfFemale: row.numOfFemale,
                                NumOfMale: row.numOfMale,
                                NumOfAnimal: row.numOfAnimal,
                                Location: row.location,
                                HasText: row.hasText,
                                HasMusic: row.hasMusic,
                                Setup: row.setup,
                                BaseOnTrend: row.baseOnTrend,
                                NumOfHastags: row.numOfHastags,
                                NumOfTags: row.numOfTags,
                                BrandShowLengthSec: row.brandShowLengthSec,
                                BrandShowPosition: row.brandShowPosition,
                                IsPitching: row.isPitching,
                                IsStrongCTA: row.isStrongCTA,
                                IsGeneralInsight: row.isGeneralInsight,
                                Modifier: row.modifier,
                                StartTime: row.startTime,
                                EndTime: row.endTime,
                            };
                            requests.push(
                                authPost(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Create', { body: JSON.stringify(newrow) })
                            );
                        }
                        Promise.all(requests)
                            .then(() => {
                                authFetch(this.props.pca, API_ACTIVITYFEATURE_PREFIX + '/Read')
                                    .then(response => response.json())
                                    .then(data => {
                                        this.handleMessage(`(${selectedRows.length}) ${dictionary.Message.Copy}`)
                                        this.setState({ data: data, rowsSelected: [] });
                                    });
                            });
                    };
                };

                //Define route
                var handlePDF = () => {
                    this.setState({
                        route: '/PDF',
                        loading: true
                    }, () => handleExportData());
                }

                var handleWord = () => {
                    this.setState({
                        route: '/Word',
                        loading: true
                    }, () => handleExportData());
                }

                var handleExcel = () => {
                    this.setState({
                        route: '/Excel',
                        loading: true
                    }, () => handleExportData());
                }

                //Export Data API connection
                var handleExportData = () => {

                    selectedRows = selRows.data.map(d => (d.dataIndex));
                    const row = data[selectedRows[0]];

                    const rows = Object.values({ row });
                    const keys = Object.keys(row);

                    const columns = keys.map(column => {
                        return {
                            key: column,
                            title: column,
                            format: "",
                            align: "right"
                        }
                    });

                    authPost(this.props.pca, API_DATAEXPORT_PREFIX + this.state.route, {
                        body: JSON.stringify({
                            fileName: "",
                            culture: "",
                            columns: columns,
                            rows: rows
                        })
                    })
                        .then(response => response.text())
                        .then(data => {
                            if ((data || {}).error) {
                                this.handleError(data.error);
                            }
                            else {
                                this.setState({
                                    fileData: data
                                }, () => handleShowData());
                            }
                        })
                }

                var handleShowData = () => {
                    var JSONdata = JSON.parse(this.state.fileData);

                    var newFileData = JSONdata.path.toString();
                    this.setState({
                        loading: false,
                        fileData: newFileData
                    }, () => this.handleMessage(dictionary.ExportData.DownloadSuccessSnackbar + this.state.fileData))
                }

                return (
                    <div className={"custom-toolbar-select"}>
                        {(selectedRows.length < 2) ? (
                            <React.Fragment>
                                <ExportDataButtons
                                    handlePDF={handlePDF}
                                    handleWord={handleWord}
                                    handleExcel={handleExcel}
                                ></ExportDataButtons>
                                <ActivityFeatureEdit pca={this.props.pca} onEditRow={this.editItem} lookupLists={this.state.lookupLists} Daatta={this.state.data} rowId={rowId} />
                                <Tooltip title={dictionary.Toolbar.Copy}>
                                    <IconButton onClick={handleCopy}>
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={dictionary.Toolbar.Delete}>
                                    <IconButton onClick={handleDelete}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Tooltip title={dictionary.Toolbar.Copy}>
                                    <IconButton onClick={handleCopy}>
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={dictionary.Toolbar.Delete}>
                                    <IconButton onClick={handleDelete}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        )}
                    </div>
                );
            },
            customToolbar: () => {
                return (
                    <React.Fragment>
                        <ActivityFeatureAdd pca={this.props.pca} onAddNewRow={this.addNewItem} lookupLists={this.state.lookupLists} />
                    </React.Fragment>
                );
            }

        };

        //dictionary.<komponentin nimi>.Title
        return (
            <div style={{ padding: 10 }}>
                <div>
                    {(this.state.loading) ? (
                        <CircularProgress />
                    ) : (
                        <MUIDataTable
                            title={dictionary.ActivityFeature.Title}
                            data={this.state.data}
                            columns={cols}
                            options={options}
                        />
                    )
                    }
                </div>
            </div>
        );
    }
}

function get_ordered_columns(list, hidden) {
    const columns = [];

    if (!Array.isArray(list)) {
        list = default_columns.map((c) => (c.name));
    }

    list.forEach(function (el) {
        columns.push((default_columns.filter(function (d) { return d.name == el; }) || [])[0]);
        if (hidden != null) {
            if (!(columns[columns.length - 1].options))
                columns[columns.length - 1].options = {};
            if (hidden.indexOf(columns[columns.length - 1].name) > -1) {
                columns[columns.length - 1].options.display = false;
            } else {
                columns[columns.length - 1].options.display = true;
            }
        }
    });

    return columns;
}